module.exports = __webpack_public_path__ + "img/honer_sys.4105f61a.png";